import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { getFunctions, provideFunctions } from '@angular/fire/functions';

import { routes } from './app.routes';
import { environment } from '@environments/environment';

import {
  DEBUG_VALUE,
  DEBUG,
  CALLABLE_2ND_GEN_BASE_URL,
  CALLABLE_2ND_GEN_BASE_URL_VALUE,
  CALLABLE_GENERATION_VERSION,
  CALLABLE_GENERATION_VERSION_VALUE,
  GOOGLE_MAP_API_KEY_VALUE,
  GOOGLE_MAP_API_KEY
} from '@config/config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes, withPreloading(PreloadAllModules)),

    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideFirestore(() => getFirestore()),
    provideStorage(() => getStorage()),
    provideFunctions(() => getFunctions()),

    { provide: DEBUG, useValue: DEBUG_VALUE },
    { provide: CALLABLE_2ND_GEN_BASE_URL, useValue: CALLABLE_2ND_GEN_BASE_URL_VALUE },
    { provide: CALLABLE_GENERATION_VERSION, useValue: CALLABLE_GENERATION_VERSION_VALUE },
    { provide: GOOGLE_MAP_API_KEY, useValue: GOOGLE_MAP_API_KEY_VALUE }
  ]
};